
import { Menu } from 'floating-vue'
import { defineComponent, PropType } from 'vue'

interface INavItem {
  label: string
  routePath: string
  separator?: boolean
}

/**
 * The floating button component introduced in the new team home layout
 */
export default defineComponent({
  name: 'FloatingButtonMobile',

  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Menu },

  props: {
    navItems: {
      type: Array as PropType<INavItem[]>,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: true
    },
    selectionLabel: {
      type: String,
      default: ''
    }
  },

  computed: {
    currentSelection(): string {
      if (this.selectionLabel) return this.selectionLabel
      const selection = this.navItems.find(({ routePath }) =>
        this.matchesCurrentRoutePath(routePath)
      )
      return selection?.label ?? ''
    }
  },

  beforeDestroy(): void {
    this.onHide()
  },

  methods: {
    /**
     * Prevent scrolling when the nav items are visible
     *
     * @returns {void}
     */
    onShow(): void {
      document.body.classList.add('overflow-hidden')
    },

    /**
     * Allow scrolling when the nav items are hidden
     *
     * @returns {void}
     */
    onHide(): void {
      document.body.classList.remove('overflow-hidden')
    },

    /**
     * Helper that returns a boolean denoting if the supplied route name matches the current
     * Used to compute the current selection (active route)
     *
     * @param {string} routePathCandidate
     * @returns {boolean}
     */
    matchesCurrentRoutePath(routePathCandidate: string): boolean {
      const { route } = this.$router.resolve(routePathCandidate)
      if (!this.$route.path.startsWith(route.path)) return false
      return Object.entries(route.query).every(
        ([key, value]) => this.$route.query[key] === value
      )
    }
  }
})
